package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.MemberRepository
import dev.zacsweers.metro.Inject

class DeleteMemberUseCase @Inject constructor(
    private val repository: MemberRepository
) {
    suspend operator fun invoke(id: String): Result<Unit> = repository.deleteMember(id)
}
